import React from '@root/vendor/react';

const FormContext = React.createContext();

export default FormContext;
